<template>
    <div id="app">
      <!-- Loader Bloc -->
      <div class="site-loader">
        <div class="loading"></div>
      </div>
      <!-- Site Wrapper -->
      <div id="site-wrapper">
        <!-- Header -->
        <header id="site-header">
          <div class="nav-top">
            <div class="container">
              <div class="row">
                <div class="col-sm-12">
                  <ul>
                    <li v-if="timeData.special.from == 0 || timeData.special.from >= (Date.now() / 1000 | 0) || timeData.special.to <= (Date.now() / 1000 | 0) "><i class="fa fa-clock-o"></i>Aujourd'hui: {{ todayTime }}</li>
                    <li v-if="timeData.special.from != 0 && timeData.special.from < (Date.now() / 1000 | 0) && timeData.special.to > (Date.now() / 1000 | 0)"><i class="fa fa-clock-o"></i>Aujourd'hui: {{ timeData.special.time }}</li>
                    <li><i class="fa fa-phone"></i>021 944 04 03</li>
                    <li class="social-bloc">
                      <a target="_blank" href="https://www.facebook.com/lapizzetta.ch/"><i class="fa fa-facebook"></i></a>
                      <a target="_blank" href="https://fr.tripadvisor.ch/Restaurant_Review-g1130892-d12355409-Reviews-La_Pizzetta-La_Tour_de_Peilz_Canton_of_Vaud.html"><i class="fa fa-tripadvisor"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="navbar" role="navigation">
            <div class="container">
              <div class="row">
                <h1 class="sr-only">La Pizzetta</h1>
                <a href="index.html" title="La Pizzetta" class="logo">
                  <img src="static/img/logo-flat.svg" alt="" width="170">
                </a>
                <button data-target=".navbar-collapse" data-toggle="collapse" type="button" class="menu-mobile visible-xs">
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                </button>
                <ul class="nav navbar-nav navbar-collapse collapse">
                  <li><a v-bind:class="{ active: $route.name == 'Accueil' }" href="#/">accueil</a></li>
                  <li><a v-bind:class="{ active: $route.name == 'Carte des mets' }" href="#/menu">carte des mets</a></li>
                  <li><a onclick="$('html,body').animate({scrollTop: $('#contact').offset().top},1500,'easeInOutQuad');">contact</a></li>
                  <li class="uber"><a href="https://www.ubereats.com/ch/store/la-pizzetta/Snc5SHZ5SJ2AUr5MTHHiKQ" target="_blank">Livraison &nbsp<img src="static/img/ubereats.svg" height="10px" alt="Uber Eats"></a></li>
                </ul>
              </div>
            </div>
          </div>
        </header>
        <!-- End Header -->
        <!-- Slide -->
        <section v-bind:class="{ reduced: $route.name == 'Carte des mets' }" id="main-slider" data-background="static/img/bg/pizza.jpg" class="parallax-window">
          <div v-if="$route.name == 'Accueil'">
            <div class="section-slogan">
              <img src="static/img/logo.svg" alt="">
            </div>
            <span class="scoll-down">Défiler vers le bas</span>
          </div>
          <div v-if="$route.name != 'Accueil'">
            <h1 class="section-title white-font text-center">{{ $route.name }}</h1>
            <ul>
              <li><a href="#/">Accueil</a></li>
              <li>{{ $route.name }}</li>
            </ul>
          </div>
        </section>
        <!-- End Slide -->
        <router-view></router-view>
        <!-- Section Contact -->
        <section id="contact">
          <div id="maps"></div>
          <div class="container">
            <div class="row">
              <div class="col-sm-8 col-md-4">
                <div class="ctc-item">
							<span class="section-suptitle text-center">
								Contact
							</span>
                  <h2 class="section-title sep-type-2 text-center">
                    Commandez vos mets
                  </h2>
                  <p class="tel">021 944 04 03</p>
                  <div class="widget">
                    <b>Adresse</b>
                    <p>
                      La Pizzetta<br />
                      Grand-Rue 5<br />
                      1814 La Tour-de-Peilz
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Footer -->
        <footer id="site-footer">
          <div class="container">
            <div class="row">
              <div class="col-sm-6 col-md-6">
                <div class="bloc-cms">
                  <img src="static/img/logo-flat.svg" alt="">
                  <p>
                    La pizza traditionnelle à longue maturation,<br />
                    à emporter chez vous.<br/>
                    Possibilité, aussi, de la déguster sur place.
                  </p>
                </div>
              </div>
              <div class="col-sm-6 col-md-6">
                <div class="open-hours">
                    <div v-if="timeData.special.from != 0">
                      <span class="foot-title">{{ timeData.special.name }}</span>
                      <span class="time">{{ timeData.special.digest }}</span>
                      <p>{{ timeData.special.time }}</p>
                    </div>
                  <span class="foot-title">Horaires d'ouverture</span>
                  <table>
                    <tr v-for="time in timeData.compact">
                      <td>{{ time.days }}</td>
                      <td>{{ time.time }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="footer-end">
            <div class="social">
              <ul>
                <li class="social-bloc">
                  <a target="_blank" href="https://www.facebook.com/lapizzetta.ch/"><i class="fa fa-facebook"></i></a>
                  <a target="_blank" href="https://fr.tripadvisor.ch/Restaurant_Review-g1130892-d12355409-Reviews-La_Pizzetta-La_Tour_de_Peilz_Canton_of_Vaud.html"><i class="fa fa-tripadvisor"></i></a>
                </li>
              </ul>
            </div>
            <div class="top">
              <a href="">Revenir en haut</a>
            </div>
          </div>
        </footer>
        <!-- End Footer -->
      </div>
      <!-- End Loader Bloc -->
    </div>
</template>

<script>
  import timeData from './data/timetable.json';
export default {
  name: 'app',
  data() {
      return {
          timeData: timeData,
          todayTime: (timeData.special.from < new Date().getTime() && timeData.special.to > new Date().getTime()) ? timeData.special.time : timeData.opening[new Date().getDay()].time
      }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// App.vue?0c9d6624